import { For, Show } from "solid-js";
import { msg } from "@lingui/core/macro";
import { useI18n } from "@/providers/i18n-provider";
import { useAccounts } from "@/features/auth/use-accounts";
import { Avatar } from "@/components/ui/avatar";

export function TryAnotherAccount() {
  const { t } = useI18n();
  const { accounts, activeUserId, switchHere } = useAccounts();

  const otherAccounts = () => {
    const currentId = activeUserId();
    return accounts().filter((account) => account.userId !== currentId && account.kind !== "guest");
  };

  return (
    <Show when={otherAccounts().length > 0}>
      <div class="mt-6 flex flex-col items-center gap-3" data-testid="try-another-account">
        <p class="text-xs font-medium text-muted-foreground">
          {t(msg`Signed in with more than one account? Try another one:`)}
        </p>
        <div class="flex flex-wrap items-center justify-center gap-2">
          <For each={otherAccounts()}>
            {(account) => (
              <button
                type="button"
                class="flex items-center gap-2 rounded-full border border-border/40 bg-card/60 px-3 py-1.5 text-xs font-medium text-foreground transition-colors hover:bg-accent/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                onClick={() => {
                  void switchHere(account.userId);
                }}
                data-testid={`try-account-${account.userId}`}
              >
                <Avatar
                  userId={account.userId}
                  name={account.displayName}
                  email={account.email}
                  image={account.avatar}
                  size="xs"
                />
                <span>{account.displayName || account.email}</span>
              </button>
            )}
          </For>
        </div>
      </div>
    </Show>
  );
}
